import React, { createContext, useContext, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

import ConferenceStatute from '../ImportantLinks/ConferenceStatute';
import PrivacyPolicy from '../ImportantLinks/PrivacyPolicy';
import RodoPolicy from '../ImportantLinks/RodoPolicy';

const DocumentModalContext = createContext(undefined);

export function DocumentModalProvider({ children }) {
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('privacy');

    const openModal = (type) => {
        setModalType(type);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setModalType('privacy');
    };

    const getModalTitle = () => {
        switch (modalType) {
            case 'privacy': return 'Polityka Prywatności';
            case 'rodo': return 'Klauzula informacyjna RODO';
            case 'statute': return 'Regulamin Konferencji';
            default: return 'Informacje';
        }
    };

    const getModalBody = () => {
        switch (modalType) {
            case 'privacy': return <PrivacyPolicy />;
            case 'rodo': return <RodoPolicy />;
            case 'statute': return <ConferenceStatute />;
            default: return <p>Domyślna treść.</p>;
        }
    };

    return (
        <DocumentModalContext.Provider value={{ openModal }}>
            {children}
            <Modal show={showModal} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{getModalTitle()}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{getModalBody()}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Zamknij</Button>
                </Modal.Footer>
            </Modal>
        </DocumentModalContext.Provider>
    );
}

export function useDocumentModal() {
    const context = useContext(DocumentModalContext);
    if (!context) {
        throw new Error('useDocumentModal must be used within a DocumentModalProvider');
    }
    return context;
}
